// import Import from './Import';

export default {
  // component: Import,
  component: load(() => import(/* webpackChunkName: "Test-Import" */ './Import')),
  priority: 9,
  permissions: ['Dashboard'],
  name: 'Import',
  icon: 'file-import',
  drawer: true,
};

